
import "../css/main.css";

import React, { Suspense } from 'react';
import { createRoot } from 'react-dom/client';
import Cookies from 'js-cookie';
import i18n from 'i18next';
import { getInstantQuoteDefault, getStats } from './services/api.js';

import {
  listenChangeLanguage,
  initSliders,
  initAccordion,
  toggleHeader,
  startMobileListenResizeForUpdateModalContentHeight,
  tableToggle,
  tabToggle,
  languageBanner,
  removeTableLimit,
} from './services/domBridge.js';

const SpokenLanguageIdentifierDemo = React.lazy(() => import("./components/SpokenLanguageIdentifierDemo"));
const LanguageIdentifierDemo = React.lazy(() => import("./components/LanguageIdentifierDemo"));
const TerminologyExtractionDemo = React.lazy(() => import("./components/TerminologyExtractionDemo"));
const ReadabilityAnalyzerDemo = React.lazy(() => import("./components/ReadabilityAnalyzerDemo"));
const SemanticRelationshipsDemo = React.lazy(() => import("./components/SemanticRelationshipsDemo"));



const i18nInit = () => {
  const data = window.i18n; // this is set by Hugo

  const language = Object.keys(data)[0];
  const resources = {};

  for (const key in data) resources[key] = { translation: data[key] };

  if (data) {
    i18n.init({ lng: language, resources }).catch(console.error);
  }
};

const attachToDOMElementAndRenderComponent = (domElementId, reactComponent) => {
  const loader = <div style={{ textAlign: "center" }}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="32" height="32" fill="#012b5c">
      <path opacity=".25" d="M16 0 A16 16 0 0 0 16 32 A16 16 0 0 0 16 0 M16 4 A12 12 0 0 1 16 28 A12 12 0 0 1 16 4" />
      <path d="M16 0 A16 16 0 0 1 32 16 L28 16 A12 12 0 0 0 16 4z">
        <animateTransform attributeName="transform" type="rotate" from="0 16 16" to="360 16 16" dur="0.8s" repeatCount="indefinite" />
      </path>
    </svg>
  </div>;

  const domElement = document.getElementById(domElementId);

  if (domElement) {
    const root = createRoot(domElement);
    root.render(
      <Suspense fallback={loader}>
        {reactComponent}
      </Suspense>);
  }
};


// rock & roll
(async () => {
  const defaults = await getInstantQuoteDefault();

  i18nInit();
  listenChangeLanguage();
  languageBanner();
  initSliders();
  initAccordion();
  toggleHeader();
  tableToggle();
  tabToggle();
  removeTableLimit();
  startMobileListenResizeForUpdateModalContentHeight();

  // Demo Components
  attachToDOMElementAndRenderComponent('spokenLanguageIdentifierDemo', <SpokenLanguageIdentifierDemo />);
  attachToDOMElementAndRenderComponent('languageIdentifierDemo', <LanguageIdentifierDemo />);
  attachToDOMElementAndRenderComponent('terminologyExtractionDemo', <TerminologyExtractionDemo />);
  attachToDOMElementAndRenderComponent('readabilityAnalyzerDemo', <ReadabilityAnalyzerDemo />);
  attachToDOMElementAndRenderComponent('semanticRelationshipsDemo', <SemanticRelationshipsDemo />);

})();
